import { ChangeEvent, FC, PropsWithChildren } from 'react';

import { Cell, CellText, Checkbox, Text, VSpacing, VSpacingContainer } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import withErrorBoundary from 'components/common/ErrorBoundary/withErrorBoundary';
import { useComputePredictedProfRoles } from 'components/CpcFlexibleCreate/PredictWindow/utils/useComputePredictedProfRoles';

import { setCampaignProfessions } from 'store/models/createCampaign';
import { useDispatch, useSelector } from 'store/utils';

const TrlKeys = {
    title: 'AdCreate.AdForm.PredictWindow.ProfRoleSelector.titleMagritte',
    subtitle: 'AdCreate.AdForm.PredictWindow.ProfRoleSelector.subtitleMagritte',
};

const ProfRoleSelectorComponent: FC<PropsWithChildren> = () => {
    const selectedProfessions = useSelector((state) => state.createCampaign.adProfessions);
    const profRoles = useComputePredictedProfRoles();
    const dispatch = useDispatch();
    const trl = useTrls();

    const onCheckboxStateChange = (e: ChangeEvent<HTMLInputElement>, id: string) =>
        dispatch(
            setCampaignProfessions(
                e.target.checked
                    ? [...selectedProfessions, id]
                    : selectedProfessions.filter((profession) => profession !== id)
            )
        );

    if (!profRoles.length) return null;

    return (
        <div>
            <VSpacingContainer default={16}>
                <div>
                    <Text typography="title-5-semibold">{trl(TrlKeys.title)}</Text>
                    <VSpacing default={4} />
                    <Text typography="label-2-regular" style="secondary">
                        {trl(TrlKeys.subtitle)}
                    </Text>
                </div>
                {profRoles.map(({ id, name }) => (
                    <Cell
                        key={id}
                        width="fit-content"
                        left={
                            <Checkbox
                                onChange={(e) => onCheckboxStateChange(e, id)}
                                value={id}
                                checked={selectedProfessions.includes(id)}
                                data-qa={`prof-role-checkbox-${id}`}
                            />
                        }
                    >
                        <CellText>{name}</CellText>
                    </Cell>
                ))}
            </VSpacingContainer>
        </div>
    );
};

const ProfRoleSelector = withErrorBoundary(ProfRoleSelectorComponent);
export { ProfRoleSelector };
